// extracted by mini-css-extract-plugin
export default {"errorBlock":"errorBlock_errorBlock__vPi+o"};